$(document).on('click', '[data-object-target="checkout"][data-object-set]', function (event) {
  event.preventDefault();
  $('#id_customer_object').val($(this).attr('data-object-set')).trigger('change');
  $('#id_customer_object_text').html($(this).attr('data-object-text'));
  $(this).closest('[data-reveal]').foundation('close');
  if ($(this).attr('data-object-customer_order_id')) {
    $('#id_customer_order_id').val($(this).attr('data-object-customer_order_id'));
  }
  if ($(this).attr('data-object-costcenter')) {
    $('#id_costcenter').val($(this).attr('data-object-costcenter'));
  }
  if ($(this).attr('data-object-custom_delivery_contact')) {
    $('#id_custom_delivery_contact').val($(this).attr('data-object-custom_delivery_contact'));
  }
  if ($(this).attr('data-object-custom_delivery_phone')) {
    $('#id_custom_delivery_phone').val($(this).attr('data-object-custom_delivery_phone'));
  }
  if ($(this).attr('data-object-custom_mandatory_notification') === 'True') {
    $('#id_custom_mandatory_notification').attr('checked', $(this).attr('data-object-custom_mandatory_notification'));
  } else {
    $('#id_custom_mandatory_notification').removeAttr('checked');
  }
});
